/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Cancel_Addons_Removed_HeadingInputs */



/**
* | output |
* | --- |
* | "The following will be removed at period end:" |
*
* @param {Sub_Cancel_Addons_Removed_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_cancel_addons_removed_heading = /** @type {((inputs?: Sub_Cancel_Addons_Removed_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Cancel_Addons_Removed_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Folgendes wird zum Periodenende entfernt:")
	return /** @type {LocalizedString} */ ("The following will be removed at period end:")
});